import { usePostApiEmbeddingCollectionDataToolImport } from "@/API";
import { Button, FileButton } from "@mantine/core";
import { PropsWithChildren, useRef, useState } from "react";

export function EmbeddingCollectionImportButton(props: { workspaceId: string, embeddingCollectionId?: string, onSuccess: () => void, onError: (e: Error) => void }) {
    const resetRef = useRef<() => void>(null);
    const import_Mutation = usePostApiEmbeddingCollectionDataToolImport()
    const [loading, setLoading] = useState(false)

    return <>
        <FileButton resetRef={resetRef} onChange={async f => {
            resetRef.current?.();
            if (f) {
                setLoading(true)
                try {
                    await import_Mutation.mutateAsync({
                        params: {
                            workspaceId: props.workspaceId,
                            embeddingCollectionId: props.embeddingCollectionId
                        },
                        data: {
                            file: f
                        }
                    })
                    props.onSuccess?.();

                } catch (e) {
                    props.onError?.(e as Error);
                }
                setLoading(false)
            }
        }} accept="application/zip">
            {(_props) => <Button loading={loading} {..._props}>匯入</Button>}
        </FileButton>
    </>
}